import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
// sentry捕获 从double代码截取
export function initError({ dsn, release, appEnv }) {
  initSentryUserInfo();
  Raven
    .config(dsn, {
      release,
      // 展示sentry上报的log，这个log太弱了，容易被被忽视
      debug: true,
      // A callback function that allows you to apply your own filters to determine if the message should be sent to Sentry.
      shouldSendCallback(data) {
        const exceptionInfo = data.exception ? data.exception.values[0] : null;
        let shouldSend = true;
        if (exceptionInfo) {
          // 捕获:throw
          // 如果是js-error的，错误，就上报sentry
          if (/^(Error|EvalError|RangeError|ReferenceError|SyntaxError|TypeError|URIError)$/.test(exceptionInfo.type)) {
            shouldSend = true;
            const reportError = data.exception.values.length === 1 ? data.exception.values[0] : data.exception.values;
            // sentry上报的log，这个log太弱了，容易被忽视，所以重点标记一下
            console.error('%c%s', 'color: white; background: red; font-size: 12px; padding: 2px;', `[ Sentry Caught Error ] ${reportError.type} : ${reportError.value}\n`, reportError);
          }
        }
        if (appEnv !== 'production') {
          // 如果是来自非生产环境，就不上报elk
          shouldSend = false;
        }

        return shouldSend;
      },
    })
    .addPlugin(RavenVue, Vue)
    .install();
}

// 登录用户记录用户信息
export function initSentryUserInfo() {
  // todo 接入用户信息
}
